import type { Decorator, FormApi } from 'final-form';

import { isNotDefined } from 'utils/ramda';

export const handleErrorsScroll = (formApi: FormApi) => {
  const errors = formApi.getState().errors;
  if (isNotDefined(errors)) return;

  const errorInputElement = document.querySelector('.custom-input-error');
  if (!errorInputElement) return;

  errorInputElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

export const scrollToErrorOnSubmitDecorator: Decorator = (formApi) => {
  const defaultSubmit = formApi.submit;
  formApi.submit = async (...args) => {
    const res = await defaultSubmit(...args);
    handleErrorsScroll(formApi);

    return res;
  };

  return () => {};
};
